<template>
  <v-dialog
    v-model="dialog"
    persistent
    :max-width="options.width"
    class="c-custom--v-dialog"
  >
    <v-card dense flat style="padding:10px;">
      <v-card-title>
        <span class="headline">継続ボーナス</span>
      </v-card-title>
      <v-card-text>
        <p>クローバーマーク <span>
            <img src="@/assets/continueBonus/cloverOn.png" width="25px" style="margin-bottom:-7px">
          </span> を獲得しました！<br/>
        この調子で頑張りましょう！</p>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="grey" text @click.native="clickCancel()">
          キャンセル
        </v-btn>
        <v-btn color="primary" @click.native="clickOK()">
          OK
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  data () {
    return {
      dialog: false,
      resolve: null,
      reject: null,
      completeIndex: null,
      options: {
        width: 500
      }
    }
  },
  methods: {
    open ({ completeIndex, options }) {
      this.dialog = true
      this.completeIndex = completeIndex
      this.options = Object.assign(this.options, options)
      return new Promise((resolve, reject) => {
        this.resolve = resolve
        this.reject = reject
      })
    },
    clickCancel () {
      this.resolve(false)
      this.dialog = false
    },
    clickOK () {
      this.resolve(true)
      this.dialog = false
    }
  }
}
</script>
